import React from "react";
import { Grid } from "@mui/material";
export function showLoadingScreen() {
  return (
    <Grid
      container
      item
      direction={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      style={{
        textAlign: "center",
        height: "100vh",
        width: "100vw",
        verticalAlign: "middle",
        position: "fixed",
        top: "0px",
        left: "0px",
        backgroundColor: "#121212",
        zIndex: 10000,
      }}
    >
      <img
        style={{ position: "relative" }}
        src="/images/loading_200.gif"
        alt="Loading screen"
      />
    </Grid>
  );
}
export function runLoading() {
  return (
    <Grid
      container
      item
      direction={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      style={{
        textAlign: "center",
        verticalAlign: "middle",
      }}
    >
      <img src="/images/loading_200.gif" />
    </Grid>
  );
}
